module.exports = __webpack_public_path__ + "static/media/bgassetleft.57d5bc37.png";